// extracted by mini-css-extract-plugin
export default {"title":"style_title__b2AaD","empty":"style_empty__ZrUlZ"};